import { useDispatch } from 'react-redux';
import {
	Col,
	Alert,
	Spinner,
	Row,
	Card,
	CardHeader,
	CardBody,
} from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getScreenList } from '../../../slices/thunks';
import { Link } from 'react-router-dom';
import AddEditScreenModal from './Add_Edit/AddEditScreenModal';
import DeleteScreenModal from './Delete/DeleteScreen';
import { getRolesList } from '../../../slices/thunks';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';

const ScreensList = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const selectorScreens = createSelector(
		state => state.Screen,
		screen => ({
			screenList: screen.screenList,
			isLoadingList: screen.isLoadingList,
			isScreenSuccess: screen.isScreenSuccess,
			error: screen.error,
			isAdding: screen.isAdding,
			isAdded: screen.isAdded,
			isAddError: screen.isAddError,
			isUpdating: screen.isUpdating,
			isUpdated: screen.isUpdated,
			isUpdateError: screen.isUpdateError,
			isDeleting: screen.isDeleting,
			isDeleted: screen.isDeleted,
			isDeleteError: screen.isDeleteError,
		})
	);

	const { screenList, isLoadingList } = useSelector(selectorScreens);

	useEffect(() => {
		dispatch(getScreenList());
	}, []);

	const [dataScreen, setDataScreen] = useState({});
	const [isEdit, setIsEdit] = useState(false);

	// const [modal, setModal] = useState(false);
	const [modalArticle, setModalArticle] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);
	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
		toggleTab('1');
		// validation.resetForm();
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	// Delete Data
	const handleClickDelete = screen => {
		setDataScreen(screen);
		setModalDelete(true);
	};

	// Update Data
	const handleClickEdit = screen => {
		setDataScreen(screen);
		handleToggleModal();
	};

	const columns = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				accessorKey: 'screen',
				columnDefType: 'display',
				
				width: 10,
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='#'
												onClick={() => {
													const screenData =
														cellProps.row.original;
													setIsEdit(true);
													handleClickEdit(screenData);
												}}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const screenData =
														cellProps.row.original;
													handleClickDelete(screenData);
												}}
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{
				header: 'Nombre',
				accessorKey: 'name',
				
			},
			{
				header: 'Descripción',
				accessorKey: 'description',
				
			},
			{
				header: 'Cant. Campos',
				accessorFn: row => row.fields?.flat().length,
				
			},
		],
		[handleClickEdit]
	);

	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>
						{/* <CardHeader className='border-0 pb-0'>
							<div className='d-flex align-items-end justify-content-end'>
								<div className='flex-shrink-0'>
									<div className='d-flex flex-wrap gap-2'>
										<button
											className='btn btn-label btn-primary'
											onClick={() => {
												setIsEdit(false);
												setDataScreen({});
												navigate('/screens/add');
											}}
										>
											<i className={`${Icons.plus} label-icon`}></i>{' '}
											Crear Pantalla
										</button>
									</div>
								</div>
							</div>
						</CardHeader> */}
						<CardBody>
							<ODataGrid
								columns={columns}
								data={screenList || []}
								isLoadingData={isLoadingList}
								customToolbarActions={[
									{
										label: 'Crear',
										icon: Icons.plus,
										onClick: () => {
											setIsEdit(false);
											setDataScreen({});
											navigate('/screens/add');
										},
										title: 'Crear Pantalla',
									}
								]}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>

			{/* <AddEditScreenModal
				dataScreen={dataScreen}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
				// activeTab={activeTab}
				// toggleTab={toggleTab}
			/> */}

			<DeleteScreenModal
				dataScreen={dataScreen}
				isOpen={modalDelete}
				handlerToggleModal={handleToggleModalDelete}
			/>
		</React.Fragment>
	);
};

export default ScreensList;
